export default __webpack_public_path__ + "media/images/flags/nj-2f3c40b709b89350ee6bbc94429e78e4.png";